import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  display: flex;
  padding: 0 20px 30px 20px;
  justify-content: center;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow-y: hidden;
  border-radius: 8px;
  height: 100%;
  font-family: ${(props) => props.theme.typography.fontFamily};
`;

export const ModalDescription = styled.section`
  margin: 0;
  ${(props) => props.theme.newTypography.textStyleBody};
  color: ${(props) => props.theme.newPalette.neutral.N600};
  p:last-child {
    margin-bottom: 0;
  }
`;

export const ModalDescriptionBold = styled.span`
  ${(props) => props.theme.newTypography.textStyleBodySemibold};
  color: ${(props) => props.theme.newPalette.neutral.N800};
`;
